import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const goTo = (hash) => {
    window.location.hash = hash;
  };

  return (
    <section className="hero-modern" id="inicio">
      <div className="hero-container">
        <div className="hero-content-modern">
          <motion.div
            className="hero-text-modern"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="hero-title-modern">
              <span className="title-main">Donde el espacio</span>
              <motion.span
                className="title-accent"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.5 }}
              >
                no tiene límites
              </motion.span>
            </h1>
            <motion.p
              className="hero-subtitle-modern"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.7 }}
            >
              Mobiliario para oficinas, lounge y espacios comerciales.
            </motion.p>
            <motion.div
              className="hero-buttons-modern"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.9 }}
            >
              <button
                type="button"
                className="btn-hero-modern-primary"
                onClick={() => goTo('productos')}
              >
                Ver productos
              </button>
              <button
                type="button"
                className="btn-hero-modern-secondary"
                onClick={() => goTo('catalogos')}
              >
                Ver catálogos
              </button>
            </motion.div>
          </motion.div>
          <motion.div
            className="hero-image-modern"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="hero-image-wrapper">
              <video
                className="hero-img"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                poster="/assets/Images/inicio.jpg"
                aria-label="Diseño de interiores moderno"
              >
                <source src="/assets/Videos/hero4.mp4" type="video/mp4" />
              </video>
              <div className="geometric-shape shape-1"></div>
              <div className="geometric-shape shape-2"></div>
            </div>
          </motion.div>
        </div>
        <motion.div
          className="hero-scroll-indicator-modern"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
        >
          <span>Desliza para explorar</span>
          <div className="scroll-line"></div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
